import { InstructionTypes } from '../../Constants'
import { Instruction } from './Instruction'

export class SelectOptionInstruction extends Instruction {
  constructor ({ name, label, waitForNoLoaders, option, scope }) {
    super({
      name,
      waitForNoLoaders,
      type: InstructionTypes.SelectOption,
      scope

    })
    this.label = label
    this.option = option
  }

  prepareInstruction (id, params) {
    this.id = id
    this.setValue(params)
  }

  setValue (params) {
    if (this.option === undefined) {
      this.setDefaultValue(params)
    }
  }

  setDefaultValue (params) {
    throw new Error('Method not implemented.')
  }

  getParsedInstruction () {
    return {
      ...super.getParsedInstruction(),
      label: this.label,
      option: this.option
    }
  }
}
